import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Link,
} from '@mui/material';
import emailjs from 'emailjs-com';
import { useState } from 'react';

export default function ContactUs() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    message: '',
  });
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      await emailjs.send(
        'service_d4t5v8q',
        'template_ppe5f0k',
        {
          name: formData.fullName,
          email: formData.email,
          message: formData.message,
          title: 'New Contact Message',
          time: new Date().toLocaleString(),
        },
        'WjxOEt7zZA_eebsDM'
      );

      alert('Message sent successfully!');
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        message: '',
      });
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Something went wrong. Please try again later.');
    }
  };
  return (
    <Box>
      <Box
        sx={{
          py: { xs: 6, md: 8 },
          bgcolor: 'primary.light',
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" color="text.primary">
          SAY HI
        </Typography>
      </Box>

      <Box sx={{ py: { xs: 6, md: 8 } }}>
        <Container maxWidth="md">
          <Typography
            variant="h4"
            fontWeight="bold"
            gutterBottom
            textAlign="center"
          >
            Contact Us
          </Typography>
          <Typography
            variant="subtitle1"
            textAlign="center"
            mb={{ xs: 3, md: 4 }}
          >
            Got any questions? Don't hesitate to reach out via email{' '}
            <Link
              href="mailto:hello@bondpay.au"
              color="primary"
              fontWeight="bold"
            >
              hello@bondpay.au
            </Link>{' '}
            or contact form below
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={{ xs: 2, md: 3 }}>
              <Grid item xs={12}>
                <TextField
                  name="fullName"
                  fullWidth
                  value={formData.fullName}
                  onChange={handleChange}
                  label="Full Name"
                  placeholder="Jane Doe"
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  name="email"
                  fullWidth
                  value={formData.email}
                  onChange={handleChange}
                  label="Email Address"
                  placeholder="jane.doe@mail.com"
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  name="phone"
                  fullWidth
                  value={formData.phone}
                  onChange={handleChange}
                  label="Phone (Optional)"
                  placeholder="04"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="message"
                  fullWidth
                  multiline
                  value={formData.message}
                  onChange={handleChange}
                  rows={5}
                  label="Your Message"
                  placeholder="Type your message here..."
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: { xs: 'center', sm: 'flex-end' },
                  }}
                >
                  <Button type="submit" variant="contained" size="large">
                    Send Message
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Box>
    </Box>
  );
}
